import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import QuizMiddleware from '../../store/middleware/quizMiddleware';
import QuizActions from '../../store/actions/quizActions';
import ErrorHandler from "../ErrorHandler/errorhandler";
import { connect } from 'react-redux';

var user;

class ShowResult extends Component {
    constructor() {
        super();
        this.state = {
            loaderState: true,
            errorPopupOpen: false,
        }
    }
    // componentWillUnmount() {
    //     this.props.history.push(`/home/${sessionStorage.getItem("panaCloudId")}`)
    // }

    componentWillReceiveProps(nextprops) {
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(!userProps){
            this.props.history.push('/');
        }
        if(nextprops.result && nextprops.result.score) {
            this.setState({
                loaderState: nextprops.loader
            })
        }

        if(nextprops.isErrorInResult) {
            this.setState({
                loaderState : false,
                errorPopupOpen: true,
            })
        }
    }
    componentDidMount() {
        this.props.showResult({
            answerSheetId: this.props.location.state.answerSheetDetails._id,
            userId: user._id,
            isTimeUp : this.props.location.state.isTimeUp,
            pc_access_token: user.pc_access_token,
            timeConsumed : this.props.location.state.timeConsumed,
            showResultToStudents: this.props.location.state.classDetails.showResultToStudents
        })
    }

    errorPopupClose = () => {
        this.props.showResult({ answerSheetId: this.props.location.state.answerSheetDetails._id,
                                isTimeUp : this.props.location.state.isTimeUp,
                                timeConsumed : this.props.location.state.timeConsumed,
                                userId: user._id,
                                pc_access_token: user.pc_access_token,
                                showResultToStudents: this.props.location.state.classDetails.showResultToStudents
                            })
        this.props.resultClear()
        this.setState({
            loaderState: true,
            errorPopupOpen: false
        })
}
    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        const { showResultToStudents } = this.props.result;
        return (
            <div style={{ top: "70px", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute" }}>
                <Paper style={{ width: "85%", padding: "1%" }}>
                    <Typography style={{ fontWeight: "bold" }}>Quiz : {this.props.location.state.quizDetails.quiz.title}</Typography>
                    <Typography style={{ fontWeight: "bold" }}>Class : {this.props.location.state.classDetails.title}</Typography>
                </Paper>
                
                {this.state.loaderState ?
                    <div style={{ marginTop: "5%" }}><CircularProgress size={80} thickness={3} style={{color : "#13a89e"}} /></div> :
                    <div style={{ maxWidth: "50%", minWidth: "80%", padding: "3%" }}> 
                    
                    {!this.state.errorPopupOpen ?                    
                    <Paper style={{ padding: "30px", textAlign: "center", marginTop: "2%" }}>
                        {showResultToStudents?
                                <div>
                                    { /*
                                        this.props.result.isPassed === true ? <Typography style={{ fontWeight: "bold", fontSize: "200%", paddingBottom: "20px" }}>Congratulations You have Passed</Typography> : <Typography style={{ fontWeight: "bold", fontSize: "200%", paddingBottom: "20px", color : "red" }}>Sorry You have Failed</Typography>
                                        */
                                    }
                                
                                <Divider />
                                <div style={{ flexDirection: "row", display: "flex", justifyContent: "space-around", paddingTop: "30px" }}>
                                    <div style={{ flexDirection: "column", display: "flex", border: "1px solid #D3D3D3", width: "40%" }}><Typography style={{ fontWeight: "bold", fontSize: "25px", width: "100%", backgroundColor: "#13a89e", color: "white" }}>Score</Typography> <Divider /> <Typography style={{ fontWeight: "bold", fontSize: "28px", paddingTop: "2%" }}>{this.props.result.score + "%"}</Typography></div>
                                    {/*
                                        <div style={{ flexDirection: "column", display: "flex", border: "1px solid #D3D3D3", width: "40%" }}><Typography style={{ fontWeight: "bold", fontSize: "25px", width: "100%", backgroundColor: "#13a89e", color: "white" }}>Correct Answers</Typography> <Divider /> <Typography style={{ fontWeight: "bold", fontSize: "28px", paddingTop: "2%" }}> {this.props.result.noOfCorrectAnswers}</Typography></div>
                                    */}
                                    
                                </div>
                            </div>
                            :
                            <div>
                                <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                    Your quiz has been submitted successfully! 
                                </Typography>
                                <br></br>
                                <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                    Results will be published over the official PIAIC communication channels and the PIAIC Student Portal.
                                </Typography>
                                <br></br>
                                <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                    Please note: As defined in the course syllabus, the PIAIC grading policy is based on a percentile ranking system. Therefore, all results will be released once testing for all students is completed.
                                </Typography>
                            </div>
                        }
                    </Paper> 
                    :
                    <ErrorHandler
                        errorPopupOpen={this.state.errorPopupOpen}
                        errorPopupClose={this.errorPopupClose.bind(this)}
                    />    
                    }
                    </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        result: state.quizReducer.showResult,
        isErrorInResult : state.quizReducer.isErrorInShowResult
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showResult: (data) => dispatch(QuizMiddleware.showResultMiddleware(data)),
        resultClear: () => {dispatch(QuizActions.ShowResult())},
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ShowResult)


// WEBPACK FOOTER //
// ./src/container/ShowResult/showresult.js